'use strict'

domConfig = undefined

module.exports =
  get: ->
    if @updatedFinchSettings
      @updatedFinchSettings = false
    else if domConfig && Object.keys(domConfig).length
      return domConfig
    domConfig = Groupon.Utils?.getConfigFromDom()
